import { render, staticRenderFns } from "./FieldItemNew.vue?vue&type=template&id=136b5698&"
import script from "./FieldItemNew.vue?vue&type=script&lang=js&"
export * from "./FieldItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports